"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = {
    CONTEXT_PROVIDER_OFFSET_KEY_SUFFIX: "_offset",
    CONTEXT_PROVIDER_LAYOUT_KEY_SUFFIX: "_layouts",
};
//# sourceMappingURL=Constants.js.map